import { EmptyState } from "@/components/system";

/**
 * Placeholder route used for sections not yet implemented in Build Week 1.
 * Real surfaces ship in their own build week per SPEC 6.14.
 */

export function Placeholder({ title }: { title: string }) {
  return (
    <article aria-labelledby="placeholder-heading">
      <p
        style={{
          fontFamily: "var(--font-sans)",
          fontSize: "var(--type-micro)",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "var(--fg-3)",
        }}
      >
        Section
      </p>
      <h1
        id="placeholder-heading"
        style={{
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
          fontWeight: 500,
          fontSize: "var(--type-display-m)",
          margin: "var(--space-2) 0 var(--space-8)",
        }}
      >
        {title}
      </h1>
      <EmptyState
        headline={`${title} — not built yet`}
        sub="Spec'd in Section 3 + 4. Implementation lands in a later build week."
      />
    </article>
  );
}
